module.exports = __webpack_public_path__ + "static/media/done_circle.74ab7327.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/integrations/done_circle.svg
// module id = 577
// module chunks = 35